export const MAP_URL = 'https://maps.app.goo.gl/Tteaa3MFZKMWv2h89';

export const content = {
  en: {
    nav: {
      logo: 'Tandartspraktijk Assenberg',
      links: [
        { text: 'About', href: '#about' },
        { text: 'Services', href: '#services' },
        { text: 'Contact', href: '#contact' },
        { text: 'Book Appointment', href: '#book' }
      ],
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      book: 'Book Appointment'
    },
    hero: {
      title: 'Welcome to Tandartspraktijk Assenberg',
      subtitle: 'Experience personalized treatment in a state-of-the-art, welcoming environment.',
      cta: 'Schedule Your Visit'
    },
    about: {
      title: 'About Us',
      subtitle: 'Modern Dental Practice',
      content: [
        'Since April 2011, Tandartspraktijk Assenberg has been located in Center Point (1st floor) at Bruggehoofd in Hellevoetsluis.',
        'Modern dental practice with dentist, dental hygienist, and prevention assistant. Thanks to this composition, we can provide our patients with good care, personal attention, and advice for your mouth and teeth.',
        'Our goal is to work with you to make the right choices for a beautiful and healthy set of teeth.'
      ],
      memberships: {
        title: 'Member of:',
        list: [
          'Royal Dutch Dental Association (KNMT)',
          'Dutch Association for Oral Implantology (NVOI)',
          'Dutch Association for Endodontology (NVvE)'
        ]
      }
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive Dental Care',
      list: [
        {
          title: 'General Dentistry',
          description: 'Comprehensive check-ups, cleanings, and preventive care to maintain your oral health.'
        },
        {
          title: 'Cosmetic Dentistry',
          description: 'Transform your smile with veneers, whitening, and other aesthetic treatments.'
        },
        {
          title: 'Orthodontics',
          description: 'Achieve a straight, beautiful smile with our custom braces and clear aligners.'
        },
        {
          title: 'Dental Implants',
          description: 'Restore missing teeth with durable, natural-looking dental implants.'
        }
      ]
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in Touch',
      address: {
        title: 'Address',
        street: 'Bruggehoofd 82',
        city: '3223 DJ Hellevoetsluis',
        country: 'The Netherlands'
      },
      phoneTitle: 'Phone',
      phoneNumber: '0181-312319',
      emailTitle: 'Email',
      emailAddress: 'info@tandartspraktijkassenberg.nl',
      hours: {
        title: 'Opening Hours',
        schedule: 'Mon-Fri: 08:00-12:00 and 13:30-16:30'
      },
      transportation: {
        title: 'Transportation',
        content: [
          'The practice is easily accessible by both car and public transport. There is plenty of parking available at the practice. There are also several bus stops within about 5 minutes walking distance.',
          'Nearby bus stops include: Police Station, Shopping Center, Canal Road, and de Sprong. Buses run towards Rozenburg and towards Spijkenisse.'
        ]
      }
    },
    footer: {
      description: 'Your trusted partner for complete oral care in a comfortable and modern environment.',
      rights: ' 2024 Tandartspraktijk Assenberg. All rights reserved.'
    }
  },
  nl: {
    nav: {
      logo: 'Tandartspraktijk Assenberg',
      links: [
        { text: 'Over ons', href: '#about' },
        { text: 'Diensten', href: '#services' },
        { text: 'Contact', href: '#contact' },
        { text: 'Afspraak maken', href: '#book' }
      ],
      about: 'Over ons',
      services: 'Diensten',
      contact: 'Contact',
      book: 'Afspraak maken'
    },
    hero: {
      title: 'Welkom bij Tandartspraktijk Assenberg',
      subtitle: 'Ervaar persoonlijke behandeling in een moderne en gastvrije omgeving.',
      cta: 'Plan uw bezoek'
    },
    about: {
      title: 'Over ons',
      subtitle: 'Moderne tandartspraktijk',
      content: [
        'Vanaf april 2011 is Tandartspraktijk Assenberg gevestigd in het Center Point (1ste verdieping) aan het Bruggehoofd in Hellevoetsluis.',
        'Moderne tandartspraktijk met tandarts, mondhygiënist en preventieassistent. Dankzij deze samenstelling kunnen wij onze patiënten van goede zorg, persoonlijke aandacht en adviezen voor uw mond en gebit voorzien.',
        'Doel is samen met u de juiste keuzes te maken voor een mooi en gezond gebit.'
      ],
      memberships: {
        title: 'Lid van:',
        list: [
          'Koninklijke Nederlandse Maatschappij tot bevordering der Tandheelkunde (KNMT)',
          'Nederlandse Vereniging voor Orale Implantologie (NVOI)',
          'Nederlandse vereniging voor Endodontologie (NVvE)'
        ]
      }
    },
    services: {
      title: 'Onze diensten',
      subtitle: 'Complete tandheelkundige zorg',
      list: [
        {
          title: 'Algemene tandheelkunde',
          description: 'Uitgebreide controles, reiniging en preventieve zorg voor uw mondgezondheid.'
        },
        {
          title: 'Cosmetische tandheelkunde',
          description: 'Transformeer uw glimlach met facings, bleken en andere esthetische behandelingen.'
        },
        {
          title: 'Orthodontie',
          description: 'Bereik een rechte, mooie glimlach met onze beugels en aligners.'
        },
        {
          title: 'Tandheelkundige implantaten',
          description: 'Herstel ontbrekende tanden met duurzame, natuurlijk ogende implantaten.'
        }
      ]
    },
    contact: {
      title: 'Contact',
      subtitle: 'Neem contact op',
      address: {
        title: 'Adres',
        street: 'Bruggehoofd 82',
        city: '3223 DJ Hellevoetsluis',
        country: 'Nederland'
      },
      phoneTitle: 'Telefoon',
      phoneNumber: '0181-312319',
      emailTitle: 'Email',
      emailAddress: 'info@tandartspraktijkassenberg.nl',
      hours: {
        title: 'Openingstijden',
        schedule: 'Ma-Vr: 08:00-12:00 en 13:30-16:30'
      },
      transportation: {
        title: 'Bereikbaarheid',
        content: [
          'De praktijk is goed bereikbaar met zowel auto als openbaar vervoer. Er is voldoende parkeergelegenheid bij de praktijk. Ook zijn er diverse bushaltes op ongeveer 5 minuten loopafstand.',
          'Nabijgelegen bushaltes zijn: Politiebureau, Winkelcentrum, Kanaalweg en de Sprong. Er rijden bussen richting Rozenburg en richting Spijkenisse.'
        ]
      }
    },
    footer: {
      description: 'Uw vertrouwde partner voor complete mondzorg in een comfortabele en moderne omgeving.',
      rights: ' 2024 Tandartspraktijk Assenberg. Alle rechten voorbehouden.'
    }
  }
};
